import { createRoot } from 'react-dom/client'
import App from './App.tsx'
import './index.css'

// Add error boundary to help identify loading issues
const rootElement = document.getElementById("root");

if (!rootElement) {
  console.error("Failed to find the root element");
  document.body.innerHTML = '<div style="color: red; padding: 20px;">Failed to find the root element</div>';
} else {
  try {
    //console.log("Initializing React application...");
    // Check environment variables on startup
    //console.log('Environment variables check on startup:');
    //console.log('VITE_HUBSPOT_API_KEY:', import.meta.env.VITE_HUBSPOT_API_KEY ? 'defined' : 'undefined');
    //console.log('ENV mode:', import.meta.env.MODE);
    createRoot(rootElement).render(<App />);
    //console.log("React application initialized successfully");
  } catch (error) {
    //console.error("Failed to render the App component:", error);
    rootElement.innerHTML = `
      <div style="color: red; padding: 20px;">
        <h2>Application Error</h2>
        <p>There was an error loading the application:</p>
        <pre>${error instanceof Error ? error.message : String(error)}</pre>
      </div>
    `;
  }
}
